<template>
  <div class="content-wrapper">
    <app-breadcrumb
      :page-title="$t('Acreditaciones')"
      :directory="$t('')"
      :icon="'trello'"
    />

    <div class="mb-primary">
      <div class="d-flex justify-content-between mb-3">
      </div>
      <app-tab :tabs="tabsHorizontal" type="horizontal" />
    </div>
    
  </div>
</template>


<script>

export default {
  name: "Tabs",
  data() {
    return {
      icon: "settings",
      tabsHorizontal: [
        {
          icon: "square",
          name: "En espera",
          component: "tab-on-old",
          permission: "",
        },

        {
          icon: "share",
          name: "Autorización Ingreso de solicitud",
          component: "tab-autorization-request",
          permission: "",
        },

        {
          icon: "navigation",
          name: "Toma de decisión",
          component: "tab-desicion-making",
          permission: "",
        },

      ],
      
    };
  },
};
</script>